import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

const SAlert = styled.div<{ error?: boolean }>`
    color: ${({ theme }) => theme.font.darkestColor};
    background-color: ${({ theme, error }) =>
        error ? theme.brandColors.CA_Light_Coral : theme.brandColors.CA_Light_Green};
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
`

export type AlertProps = {
    className?: ClassName
    style?: React.CSSProperties
    error?: boolean
    message: string
    dataTestId?: string
}

export function Alert({ dataTestId, className, style, error, message }: AlertProps): React.ReactElement {
    return (
        <SAlert
            className={cn(className)}
            style={style}
            error={error}
            data-testid={dataTestId ?? 'alert-' + (error ? 'error' : 'success')}
        >
            {message}
        </SAlert>
    )
}
